import React, { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import { PageHero } from "@/components/Shared";
import { BRAND, IMG } from "@/lib/site";

const Block = ({ title, children }) => (
  <div className="mt-10 first:mt-0">
    <h2 className="text-[19px] font-bold sm:text-[23px]">{title}</h2>
    <div className="prose-de mt-4 text-[14.5px] sm:text-[15px]">{children}</div>
  </div>
);

export const Impressum = () => {
  const crumbs = [
    { label: "Startseite", to: "/" },
    { label: "Impressum", to: "/impressum" },
  ];
  return (
    <main data-testid="page-impressum">
      <Seo
        title="Impressum | Bremer Schneemann – Winterdienst Bremen"
        description="Impressum von Bremer Schneemann, Winterdienst Bremen. Inhaber Adil Altun, Flughafenallee 26, 28199 Bremen."
        path="/impressum"
        breadcrumbs={crumbs}
        image={IMG.heroStreet}
      />
      <PageHero label="/ Rechtliches" titleLines={["Impressum"]} breadcrumbs={crumbs} />
      <section className="bg-white py-16 lg:py-24">
        <div className="shell max-w-3xl">
          <Block title="Angaben gemäß § 5 DDG">
            <p>
              <strong>Hauptbüro / Firmensitz</strong>
              <br />
              {BRAND.name}
              <br />
              {BRAND.street}
              <br />
              {BRAND.streetExtra}
              <br />
              {BRAND.zip} {BRAND.city}
            </p>
            <p>
              <strong>Fuhrpark</strong>
              <br />
              {BRAND.fleet}
            </p>
          </Block>
          <Block title="Kontakt">
            <p>
              Telefon:{" "}
              <a href={BRAND.phoneHref} className="font-semibold text-[#0757B8]">
                {BRAND.phone}
              </a>
              <br />
              E-Mail:{" "}
              <a href={BRAND.emailHref} className="font-semibold text-[#0757B8]">
                {BRAND.email}
              </a>
            </p>
          </Block>
          <Block title="Vertreten durch">
            <p>
              {BRAND.owner}
              <br />
              Inhaber
            </p>
          </Block>
          <Block title="Umsatzsteuer-ID">
            <p>{BRAND.vatId}</p>
          </Block>
          <Block title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
            <p>
              {BRAND.owner}
              <br />
              {BRAND.street}
              <br />
              {BRAND.zip} {BRAND.city}
            </p>
          </Block>
          <Block title="Verbraucherstreitbeilegung / Universalschlichtungsstelle">
            <p>
              Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen. Die Plattform der EU zur
              Online-Streitbeilegung (OS-Plattform) wurde zum 20. Juli 2025 eingestellt.
            </p>
          </Block>
          <Block title="Haftung für Inhalte">
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen
              Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir
              als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
              rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
              Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
              Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
              konkreten Rechtsverletzung möglich. Bei Bekanntwerden entsprechender
              Rechtsverletzungen entfernen wir diese Inhalte unverzüglich.
            </p>
          </Block>
          <Block title="Haftung für Links">
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
              keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
              Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
              Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
              Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft; rechtswidrige
              Inhalte waren nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten
              Seiten ist ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
              Bekanntwerden von Rechtsverletzungen entfernen wir solche Links unverzüglich.
            </p>
          </Block>
          <Block title="Urheberrecht">
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
              unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
              Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
              bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
              Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber
              erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
              Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
              Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden
              Hinweis.
            </p>
          </Block>
          <Block title="Bildnachweise">
            <p>
              Fotos der Winterdiensteinsätze: {BRAND.name} (eigene Aufnahmen). Weitere Bilder:
              Unsplash sowie ein Foto der Bremer Stadtmusikanten. Logo: {BRAND.name}.
            </p>
          </Block>
        </div>
      </section>
    </main>
  );
};

export const Datenschutz = () => {
  const crumbs = [
    { label: "Startseite", to: "/" },
    { label: "Datenschutz", to: "/datenschutz" },
  ];
  return (
    <main data-testid="page-datenschutz">
      <Seo
        title="Datenschutzerklärung | Bremer Schneemann"
        description="Datenschutzerklärung von Bremer Schneemann, Winterdienst Bremen: Informationen zur Verarbeitung personenbezogener Daten und zu Ihren Rechten."
        path="/datenschutz"
        breadcrumbs={crumbs}
        image={IMG.heroStreet}
      />
      <PageHero label="/ Rechtliches" titleLines={["Datenschutz"]} breadcrumbs={crumbs} />
      <section className="bg-white py-16 lg:py-24">
        <div className="shell max-w-3xl">
          <Block title="1. Verantwortlicher">
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
              <br />
              {BRAND.name}, {BRAND.owner}, {BRAND.street}, {BRAND.zip} {BRAND.city}, Telefon{" "}
              {BRAND.phone}, E-Mail {BRAND.email}.
            </p>
          </Block>
          <Block title="2. Anfrageformular und Kontaktaufnahme">
            <p>
              Wenn Sie das Anfrageformular absenden, werden Ihre Eingaben (z. B. Name,
              Rufnummer, optional E-Mail-Adresse, Adresse und Art des Objekts, gewünschte
              Leistung, Nachricht) an unseren Server übermittelt, dort zur Bearbeitung
              gespeichert und per E-Mail an unser Büro weitergeleitet. Für den
              E-Mail-Versand nutzen wir einen technischen Dienstleister als
              Auftragsverarbeiter. Alternativ können Sie uns per Telefon, WhatsApp oder
              E-Mail kontaktieren. Die Daten verwenden wir ausschließlich zur Bearbeitung
              Ihrer Anfrage und zur Erbringung der beauftragten Leistungen; sie werden
              gelöscht, sobald sie für diesen Zweck nicht mehr erforderlich sind und keine
              gesetzlichen Aufbewahrungsfristen entgegenstehen. Rechtsgrundlage ist Art. 6
              Abs. 1 lit. b DSGVO (Vertrag bzw. Vertragsanbahnung) sowie Art. 6 Abs. 1
              lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).
            </p>
          </Block>
          <Block title="3. Server-Logfiles">
            <p>
              Beim Aufruf dieser Website werden durch den Hosting-Anbieter automatisch
              Informationen in Server-Logfiles gespeichert, die Ihr Browser übermittelt –
              etwa Browsertyp und -version, verwendetes Betriebssystem, Referrer-URL,
              Uhrzeit der Serveranfrage und IP-Adresse. Diese Daten dienen dem sicheren und
              stabilen Betrieb der Website; Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
            </p>
          </Block>
          <Block title="4. Cookies">
            <p>
              Diese Website verwendet ausschließlich technisch notwendige Mittel für die
              Darstellung der Seite. Es werden keine Cookies für Marketing-, Tracking- oder
              Analysezwecke eingesetzt. Sollten künftig weitere Cookies zum Einsatz kommen,
              erfolgt dies erst nach Ihrer Einwilligung.
            </p>
          </Block>
          <Block title="5. Externe Dienste">
            <p>
              Von dieser Website aus verlinken wir auf WhatsApp (WhatsApp Ireland Limited).
              Beim Klick auf den WhatsApp-Link verlassen Sie unsere Website; es gelten dann
              die Datenschutzbestimmungen des jeweiligen Anbieters. Eingebundene Bilddateien
              können von externen Bilddiensten geladen werden; dabei wird Ihre IP-Adresse an
              den jeweiligen Anbieter übertragen.
            </p>
          </Block>
          <Block title="6. Speicherdauer">
            <p>
              Wir speichern personenbezogene Daten nur so lange, wie es für die genannten
              Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen dies vorsehen.
            </p>
          </Block>
          <Block title="7. Ihre Rechte">
            <p>
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
              Verarbeitung, Datenübertragbarkeit und Widerspruch gegen die Verarbeitung.
              Erteilte Einwilligungen können Sie jederzeit widerrufen. Zudem steht Ihnen ein
              Beschwerderecht bei einer Datenschutzaufsichtsbehörde zu; zuständig ist die
              Landesbeauftragte für Datenschutz und Informationsfreiheit der Freien
              Hansestadt Bremen.
            </p>
          </Block>
          <Block title="8. Kontakt in Datenschutzfragen">
            <p>
              Für Anliegen zum Datenschutz erreichen Sie uns unter{" "}
              <a href={BRAND.emailHref} className="font-semibold text-[#0757B8]">
                {BRAND.email}
              </a>
              .
            </p>
          </Block>
        </div>
      </section>
    </main>
  );
};

export const CookieSettings = () => {
  const crumbs = [
    { label: "Startseite", to: "/" },
    { label: "Cookie-Einstellungen", to: "/cookie-einstellungen" },
  ];

  const [prefs, setPrefs] = useState({ statistik: false, marketing: false });
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    try {
      const raw = window.localStorage.getItem("bs-cookie-prefs");
      if (raw) setPrefs({ statistik: false, marketing: false, ...JSON.parse(raw) });
    } catch (e) {
      /* localStorage nicht verfügbar */
    }
  }, []);

  const save = (next) => {
    const value = next || prefs;
    setPrefs(value);
    try {
      window.localStorage.setItem("bs-cookie-prefs", JSON.stringify(value));
    } catch (e) {
      /* ignorieren */
    }
    setSaved(true);
    window.setTimeout(() => setSaved(false), 4000);
  };

  const rows = [
    {
      id: "notwendig",
      title: "Technisch notwendig",
      text:
        "Erforderlich für die Darstellung der Seite, die Navigation und das Speichern Ihrer Cookie-Auswahl. Diese Kategorie kann nicht deaktiviert werden.",
      detail: "Speicherort: localStorage · Schlüssel: bs-cookie-prefs · Laufzeit: bis zum Löschen",
      locked: true,
      on: true,
    },
    {
      id: "statistik",
      title: "Statistik / Analyse",
      text:
        "Würde anonymisierte Nutzungsdaten auswerten, um die Seite zu verbessern. Aktuell ist kein Analysedienst eingebunden – die Einstellung wird für künftige Erweiterungen vorgehalten.",
      detail: "Derzeit eingesetzte Dienste: keine",
      locked: false,
      on: prefs.statistik,
    },
    {
      id: "marketing",
      title: "Marketing",
      text:
        "Würde Daten für Werbezwecke oder Remarketing verwenden. Aktuell ist kein Marketing-Dienst eingebunden und es werden keine Werbe-Cookies gesetzt.",
      detail: "Derzeit eingesetzte Dienste: keine",
      locked: false,
      on: prefs.marketing,
    },
  ];

  return (
    <main data-testid="page-cookies">
      <Seo
        title="Cookie-Einstellungen | Bremer Schneemann"
        description="Cookie-Einstellungen für bremer-schneemann.de: Diese Website verwendet ausschließlich technisch notwendige Mittel und keine Tracking-Cookies. Auswahl jederzeit änderbar."
        path="/cookie-einstellungen"
        breadcrumbs={crumbs}
        image={IMG.heroStreet}
      />
      <PageHero
        label="/ Rechtliches"
        titleLines={["Cookie-Einstellungen"]}
        intro="Transparent und ohne Tracking: Diese Website setzt ausschließlich technisch notwendige Mittel ein. Hier können Sie Ihre Auswahl einsehen und festlegen."
        breadcrumbs={crumbs}
      />
      <section className="bg-white py-16 lg:py-24">
        <div className="shell max-w-3xl">
          <div className="grid gap-3" data-testid="cookie-rows">
            {rows.map((r) => (
              <div
                key={r.id}
                className="rounded-2xl border border-[#DCE5EF] bg-white p-6"
                data-testid={`cookie-row-${r.id}`}
              >
                <div className="flex items-start justify-between gap-5">
                  <div>
                    <p className="text-[16.5px] font-bold tracking-tight">{r.title}</p>
                    <p className="mt-2 text-[13.5px] leading-relaxed text-[#66788A]">{r.text}</p>
                    <p className="font-mono-label mt-3 text-[9.5px] text-[#9AA9B8]">{r.detail}</p>
                  </div>
                  <button
                    type="button"
                    role="switch"
                    aria-checked={r.on}
                    aria-label={`${r.title} ${r.on ? "deaktivieren" : "aktivieren"}`}
                    disabled={r.locked}
                    data-testid={`cookie-toggle-${r.id}`}
                    onClick={() => !r.locked && setPrefs((p) => ({ ...p, [r.id]: !p[r.id] }))}
                    className={`relative mt-1 h-7 w-12 shrink-0 rounded-full transition-colors duration-300 ${
                      r.on ? "bg-[#0757B8]" : "bg-[#DCE5EF]"
                    } ${r.locked ? "cursor-not-allowed opacity-60" : ""}`}
                  >
                    <span
                      className="absolute top-1 h-5 w-5 rounded-full bg-white shadow-sm transition-all duration-300"
                      style={{ left: r.on ? 26 : 4 }}
                    />
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 grid gap-2.5 sm:grid-cols-2">
            <button
              type="button"
              onClick={() => save({ statistik: false, marketing: false })}
              data-testid="cookie-reject"
              className="btn btn-ghost h-13 py-3.5 text-sm"
            >
              Nur notwendige
            </button>
            <button
              type="button"
              onClick={() => save()}
              data-testid="cookie-save"
              className="btn btn-orange h-13 py-3.5 text-sm"
            >
              Auswahl speichern
            </button>
          </div>

          {saved && (
            <p
              data-testid="cookie-saved"
              className="mt-4 rounded-xl bg-[#EEF6FF] px-4 py-3 text-[13.5px] font-medium text-[#0757B8]"
            >
              Ihre Auswahl wurde gespeichert. Sie können sie auf dieser Seite jederzeit ändern.
            </p>
          )}

          <Block title="Was bedeutet das konkret?">
            <p>
              Diese Website lädt keine Analyse-, Tracking- oder Werbedienste. Es werden keine
              Profile gebildet und keine Daten an Werbenetzwerke übermittelt. Gespeichert wird
              ausschließlich Ihre Auswahl auf dieser Seite – lokal in Ihrem Browser.
            </p>
            <p>
              Beim Klick auf unseren WhatsApp-Link verlassen Sie diese Website; dort gelten die
              Bestimmungen des Anbieters. Eingebundene Bilddateien können von externen
              Bilddiensten geladen werden, wodurch Ihre IP-Adresse an den jeweiligen Anbieter
              übertragen wird.
            </p>
          </Block>
          <Block title="Auswahl im Browser löschen">
            <p>
              Sie können die gespeicherte Auswahl jederzeit über die Website-Daten Ihres Browsers
              löschen. Danach gilt wieder die Standardeinstellung „nur technisch notwendig“.
            </p>
          </Block>
          <Block title="Fragen?">
            <p>
              Details zur Datenverarbeitung finden Sie in unserer Datenschutzerklärung. Bei
              Rückfragen erreichen Sie uns unter{" "}
              <a href={BRAND.emailHref} className="font-semibold text-[#0757B8]">
                {BRAND.email}
              </a>
              .
            </p>
          </Block>
        </div>
      </section>
    </main>
  );
};
